import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { Hidden } from '@material-ui/core';

import { useTranslation } from 'react-i18next';

// style
import styles from './style';

const useStyles = makeStyles(styles);

export default function WlLegend() {
  const { t } = useTranslation();
  const classes = useStyles();

  function FormRow() {
    return (
      <>
        <Grid container direction="row" spacing={0}>
          <Grid item xs sm={2} md className={classes.boxLevel}>
            <Box>
              <Box p={0.5} className={`${classes.color} ${classes.color0}`}>{'>0-10'}</Box>
              <Box p={1} className={classes.title}>
                <Hidden smDown>{t('ฝนเล็กน้อย')}</Hidden>
                <Hidden mdUp>{t('ฝนน้อย')}</Hidden>
              </Box>
            </Box>
          </Grid>
          <Grid item xs sm md className={classes.boxLevel}>
            <Box display="flex">
              <Box p={0.5} width="50%" className={`${classes.color} ${classes.color10}`}>{'>10-20'}</Box>
              <Box p={0.5} width="50%" className={`${classes.color} ${classes.color20}`}>{'>20-35'}</Box>
            </Box>
            <Box p={1} className={classes.title}>{t('ฝนปานกลาง')}</Box>
          </Grid>
          <Grid item xs sm md className={classes.boxLevel}>
            <Box display="flex">
              <Box p={0.5} width="100%" className={`${classes.color} ${classes.color35}`}>{'>35-50'}</Box>
              <Box p={0.5} width="100%" className={`${classes.color} ${classes.color50}`}>{'>50-70'}</Box>
              <Box p={0.5} width="100%" className={`${classes.color} ${classes.color70}`}>{'>70-90'}</Box>
            </Box>
            <Box p={1} className={classes.title}>{t('ฝนหนัก')}</Box>
          </Grid>
          <Grid item xs sm={2} md className={classes.boxLevel} style={{ borderRight: '1px solid #ccc' }}>
            <Box>
              <Box p={0.5} className={`${classes.color} ${classes.color90}`}>{'>90'}</Box>
              <Box p={1} className={classes.title}>
                <Hidden smDown>{t('ฝนหนักมาก')}</Hidden>
                <Hidden mdUp>{t('ฝนมาก')}</Hidden>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </>
    );
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={0}>
        <FormRow />
      </Grid>
    </div>
  );
}
